/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".step-2[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-align:center;font-weight:700;font-size:1.1rem;margin-bottom:50px}"];
export { styles as styles };
